<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px"
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-card max-height="100%">  
      <v-card-title style="background-color: #004056" class="white--text">
        Offered Services?
      </v-card-title>

      <v-divider />

      <!-- categories -->
      <v-card-text class="px-3" :style="{overflow: 'auto', height: $vuetify.breakpoint.height * 0.7 + 'px'}">
        <ServicesInput v-model="service_ids" />
      </v-card-text>

      <v-divider />
      <!-- buttons -->
      <v-card-actions class="justify-center">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn class="ml-3" color="primary" @click="saveClick">Save</v-btn>
      </v-card-actions>
    </v-card>
    <ErrorOverlay
      title="Error Updating Services" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-dialog>
</template>

<script>
import { ActivatorButton, ErrorOverlay } from '@/components/pages';
import { ServicesInput } from '@/components/inputs'
import { mapActions } from 'vuex'

export default {
  props: ['offered'],

  components: { ActivatorButton, ErrorOverlay, ServicesInput },

  data() {
    return {
      dialogVisible: false,
      service_ids: [],

      // error handling
      loading: false,
      error_dialog: false,
      error_message: '',
    }
  },

  watch: {
    offered(new_values) {
      this.service_ids = new_values.map(s => s.service_id)
    },
  },

  methods: {
    ...mapActions('auth', ['updateMyServices']),

    close() {
      this.dialogVisible = false
    },

    async saveClick() {
      let { service_ids } = this
      const payload = { service_ids }
    
      this.loading = true
      const result = await this.updateMyServices(payload)
      this.loading = false

      if (result.ok) {
        this.$emit('reload')
        this.close()
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    },
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>